
class Time {
    constructor(wrapper, subContent){
        if(!window.history) return false;
        this._createElements(wrapper, subContent);
        this._addEvents();
    }

    _createElements(wrapper, subContent){
        this.wrapper = wrapper;
        this.subContent = subContent;
        this.btnAll = this.wrapper.querySelectorAll('[data-Time-btn]');
    }

    _addEvents(){
        var self = this;

        for(var i=0,j=this.btnAll.length; i<j; i++){
            this.btnAll[i].onclick = function() {
                self._prepareToShow.call(self, this); /* напрмиер, в сортировке по расположению предварительно пытаемся проставлять координаты */
                return false;
            }
        }
    }

    _prepareToShow(btn){
        var param = btn.getAttribute('data-Time-btn');

        //
        if(this.subContent.frame.className.indexOf('js-loading') === -1) this.subContent.frame.className = this.subContent.frame.className + ' js-loading';

        if(!param){
            this._showTime(btn);
        }
        else {
            param = JSON.parse(param);
            switch (param.type) {
                case 'geo' :{
                    this._getLocation(btn);
                    break;
                }
                default: this._showTime(btn);
            }
        }
    }

    _getLocation(btn){
        if (!navigator.geolocation){
            this._showTime(btn);
        }
        else {
            console.log('geolocation', 'navigator.geolocation ');
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    console.log('geolocation', 'navigator.geolocation success');
                    var search = btn.search;
                    var coords = 'long='+position.coords.longitude+'&lat='+position.coords.latitude;
                    btn.search = search ? search + '&' + coords : '?' + coords;
                    this._showTime(btn);
                },
                () => {
                    console.log('geolocation', 'navigator.geolocation error');
                    this._showTime(btn);
                },
                {
                    timeout: 5000
                }
            );
        }
    }

    _showTime(btn){
        window.history.pushState({ind:this.subContent.curInd, pathname:btn.pathname, search:btn.search}, '', btn.pathname + btn.search);

        this._sendStat(btn.pathname + btn.search);

        this.subContent.moduleAllRemove();

        var param = {};
        param.data = this.subContent._getAjaxData(btn.search);
        param.url = this.subContent.ajaxPart + btn.pathname + btn.search;

        this.subContent.getContent(param);
    }

    _sendStat(page){
        try{
            // ga('set', 'page', page);
            // ga('send', 'pageview');

            gtag('config', 'UA-21667993-5', {
                'page_path': page
            });
            if(console) console.log('GA при переключении сортировки обновлен - ' + page);
        } catch(e){
            if(console) console.error('GA при переключении сортировки не сработал');
        }
    }
}

export {Time};